import { render } from "./RuleRegulationAssessment.vue?vue&type=template&id=3da8385a"
import script from "./RuleRegulationAssessment.vue?vue&type=script&lang=js"
export * from "./RuleRegulationAssessment.vue?vue&type=script&lang=js"

import "./RuleRegulationAssessment.vue?vue&type=style&index=0&id=3da8385a&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__